import { object, number, string, create } from 'superstruct'

export const CreateParams = object({
  id: number(),
  name: string(),
  abbr: string()
})

export class Federation {
  static create(params) {
    return new Federation(create(params, CreateParams))
  }

  constructor(params) {
    Object.assign(this, params)
  }
}
